define('modules/static-data-fetcher/js/controller/static-data-fetcher-controller',['require','sdk!ivCore','jquery','ivUnderscore','sdk!ivoauth','plugin!artifacts:repositories','./../config/static-data-config','./../model/static-data-fetcher-model','./../usecase-service/agents-options-ucs','./../usecase-service/annualLists-options-ucs','./../usecase-service/country-options-ucs','./../usecase-service/state-options-ucs','./../usecase-service/industry-options-ucs','./../usecase-service/jobfunctions-options-ucs','./../usecase-service/joblevels-options-ucs','./../usecase-service/techdata-options-ucs','./../usecase-service/locations-options-ucs','./../usecase-service/intenttopics-options-ucs'],function(require) {
    "use strict";
    
    var iv = require('sdk!ivCore'),
    	$ = require('jquery'),
    	_ = require('ivUnderscore'),
    	IVoAuth = require('sdk!ivoauth'),
    	Commons = require('plugin!artifacts:repositories'),
        staticDataConfig = require('./../config/static-data-config'),
        StaticDataFetcherModel = require('./../model/static-data-fetcher-model'),
        AgentsOptionsService = require('./../usecase-service/agents-options-ucs'),
		AnnualListsOptionsService = require('./../usecase-service/annualLists-options-ucs'),
		CountryOptionsService = require('./../usecase-service/country-options-ucs'),
		StateOptionsService = require('./../usecase-service/state-options-ucs'),
		IndustryOptionsService = require('./../usecase-service/industry-options-ucs'),
		JobFunctionsOptionsService = require('./../usecase-service/jobfunctions-options-ucs'),
		JobLevelsOptionsService = require('./../usecase-service/joblevels-options-ucs'),
		TechDataOptionsService = require('./../usecase-service/techdata-options-ucs'),
        LocationsOptionsService = require('./../usecase-service/locations-options-ucs'),
        IntentTopicsOptionsService = require('./../usecase-service/intenttopics-options-ucs');
    
   
    var StaticDataFetcherController = iv.Controller.extend({
    	state: {
    		deferred: {
    			countryOptionsDeferred: null,
    			stateOptionsDeferred: null,
    			industryOptionsDeferred: null,
    			jobFunctionsOptionsDeferred: null,
    			jobLevelsOptionsDeferred: null,
    			agentsOptionsDeferred: null,
    			techDataOptionsDeferred: null,
                annualListsOptionsDeferred: null,
                locationsOptionsDeferred: null,
                intentTopicsOptionsDeferred: null
    		}
    	},
    	
    	initialize: function (options) {
			var staticData = Commons.DataRepo.getCustomData("staticApiData");
    		if (!staticData) {
				if(!this.setStaticDataFromSessionStorage())	{
					this.createDeferreds();
	    			this.initiateServiceCalls();
				}
    		}
    	},
    	
    	initializeModel: function (options) {
    		this.model = new StaticDataFetcherModel();
    	},
    	
    	fetchStaticData: function () {
    		var staticData = Commons.DataRepo.getCustomData("staticApiData");
    		if (!staticData) {
    			this.createDeferreds();
    			this.initiateServiceCalls();
    			return;
    		}
    		return staticData;
    	},

		setStaticDataFromSessionStorage : function() {
			var ivStaticDataObj = JSON.parse(sessionStorage.getItem("ivStaticData"));
			if(_.isDefined(ivStaticDataObj)) {
				this.model.set(ivStaticDataObj);
				Commons.DataRepo.setCustomData({"staticApiData": ivStaticDataObj});
				iv.facade.publish('static.api.data.fetched', ivStaticDataObj);
				return true;		
			}
			return false;
		},
    	
    	setStaticData: function () {
            this.setStaticDataFromConfig();
    		var model = this.model.toJSON();
			//sessionStorage.setItem("ivStaticData", JSON.stringify(model));
    		Commons.DataRepo.setCustomData({"staticApiData": model});
    		iv.facade.publish('static.api.data.fetched', model);
    	},
    	   
        setStaticDataFromConfig: function () {
            _.each(staticDataConfig, function (obj, key) {
                this.model.set(key, obj);
            }, this);  
        },
    	getStaticData: function () {
    		return this.fetchStaticData();
    	},
    	
    	createDeferreds: function () {
    		var self = this;
    		
    		_.each(Object.keys(this.state.deferred), function (dfrrdObjName) {
    			self.state.deferred[dfrrdObjName] = $.Deferred();
    		});
    		
    		$.when(self.state.deferred.annualListsOptionsDeferred.done(),
    				self.state.deferred.countryOptionsDeferred.done(),
                    self.state.deferred.stateOptionsDeferred.done(),
                    self.state.deferred.agentsOptionsDeferred.done(),
                    self.state.deferred.industryOptionsDeferred.done(),
                    self.state.deferred.jobFunctionsOptionsDeferred.done(),
                    self.state.deferred.jobLevelsOptionsDeferred.done(),
    				self.state.deferred.techDataOptionsDeferred.done(),
                    self.state.deferred.locationsOptionsDeferred.done(),
                    self.state.deferred.intentTopicsOptionsDeferred.done()).then(function(){
        			self.setStaticData();
        		});
    	},
    	
    	initiateServiceCalls: function () {
    		var serviceOptions = {
    			beforeSend: function(request) {
        			var V2accessToken = _.isDefined(IVoAuth.getInstance()) && _.isDefined(IVoAuth.getInstance().getAccessToken()) ?  IVoAuth.getInstance().getAccessToken() : localStorage.ivAccessTokenV2;
        			request.setRequestHeader("accessToken", V2accessToken);
    			}
    		};
            var key;
            for (key in this.services){
                if (this.services.hasOwnProperty(key)) {
                    this.services[key].read(serviceOptions);
                }
            }
    	},
    	
    	initializeService : function(options) {
    		var staticApiDataURL = Commons.URLRepo.getURL({key : ["contMS", "staticData"]});

            this.services = {};
    		this.services.countryOptions = new CountryOptionsService({
    			url : staticApiDataURL + "countries",
    			model: this.model
    		});

            this.services.stateOptions = new StateOptionsService({
                url : staticApiDataURL + "states",
                model: this.model
            });

            this.services.annualListsOptions = new AnnualListsOptionsService({
                url : staticApiDataURL + "annualListsAndIndexes",
                model: this.model
                
            });
    		
    		this.services.industryOptions = new IndustryOptionsService({
    			url : staticApiDataURL + "industries",
    			model: this.model
    		});
    		
    		this.services.jobFunctionsOptions = new JobFunctionsOptionsService({
    			url : staticApiDataURL + "jobFunctionsV2",
    			model: this.model
    		});
    		
    		this.services.jobLevelsOptions = new JobLevelsOptionsService({
    			url : staticApiDataURL + "jobLevelsV2",
    			model: this.model
    		});
    		
    		this.services.agentsOptions = new AgentsOptionsService({
    			url : staticApiDataURL + "agents",
    			model: this.model
    		});
    		
    		this.services.techDataOptions = new TechDataOptionsService({
    			url : staticApiDataURL + "techUsed",
    			model: this.model
    		});

            this.services.locationsOptions = new LocationsOptionsService({
                url : staticApiDataURL + "companyLocation",
                model: this.model
            });
            this.services.intentTopicsOptions = new IntentTopicsOptionsService({
                url : window.windowOrigin + "/ui-latest/intent-topics/intent_topics.json",
                model: this.model
            });
    	},
    	
    	registerListener: function () {
    		this.listenTo(this.services.countryOptions, 'fetch.country.options.success', this.staticAPIDataResolver);
            this.listenTo(this.services.stateOptions, 'fetch.states.options.success', this.staticAPIDataResolver);
    		this.listenTo(this.services.annualListsOptions, 'fetch.annualLists.options.success', this.staticAPIDataResolver);
    		this.listenTo(this.services.agentsOptions, 'fetch.agents.options.success', this.staticAPIDataResolver);
    		this.listenTo(this.services.industryOptions, 'fetch.industry.options.success', this.staticAPIDataResolver);
    		this.listenTo(this.services.jobFunctionsOptions, 'fetch.jobfunctions.options.success', this.staticAPIDataResolver);
    		this.listenTo(this.services.jobLevelsOptions, 'fetch.joblevels.options.success', this.staticAPIDataResolver);
    		this.listenTo(this.services.techDataOptions, 'fetch.techdata.options.success', this.staticAPIDataResolver);
            this.listenTo(this.services.locationsOptions, 'fetch.locations.options.success', this.staticAPIDataResolver);
            this.listenTo(this.services.intentTopicsOptions, 'fetch.intenttopics.options.success', this.staticAPIDataResolver);
    	},
    	
    	staticAPIDataResolver: function (key, response) {
    		this.state.deferred[key + "OptionsDeferred"].resolve(response);
    	}
    });
    
    return StaticDataFetcherController;
});
